import UserService from "@/services/UserService";
import SurveyService from "@/services/SurveyService";

export default {
  users: {
    list: [],
    loader: UserService.list,
    touched: false,
    clearRoute: "setting-users",
  },
  getLaunchYears: {
    list: [],
    loader: SurveyService.getLaunchYears,
    touched: false,
  },
  getProgramType: {
    list: [],
    loader: SurveyService.getProgramType,
    touched: false,
  },
  getProgramMajor: {
    list: [],
    loader: SurveyService.getProgramMajor,
    touched: false,
  },
};
